<template>
  <div>
    <nav-breadcrumb :menu="[{label: '用款申请'}]"/>
    <el-tabs v-model="applicationStatus">
      <el-tab-pane label="待审核" name="Pending Approval" />
      <!-- <el-tab-pane label="审核通过" name="Approved" />-->
      <el-tab-pane label="已审核" name="Completed,Approved" />
    </el-tabs>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="listData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "LoanApprovalList",
      data(){
        return {
          page: 1,
          pageSize: 20,
          listData: {},
          applicationStatus:'Pending Approval',
          filters: {
            labelWidth: '150px',
            form: {
              fi__transactionNo:'',
              fi__customerName:'',
              pay__applicationStatus:'',
              pay__paymentDate:[],
            },
            columns: [
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'fi__customerName',

              },
              {
                label: '贷款编号',
                component: 'el-input',
                field: 'fi__transactionNo',

              },
              /*{
                label: '状态',
                component: 'el-select',
                field: 'pay__applicationStatus',
                options:[
                  {
                    label:'待审核',
                    value:'Pending Approval'
                  },
                  {
                    label:'审核通过',
                    value:'Approved'
                  },
                  {
                    label:'已退回',
                    value:'Rejected'
                  },
                ]

              },*/
              {
                label: '申请放款日期',
                component: 'date-range-picker',
                field: 'pay__paymentDate',
                op: ['gteq', 'lteq'],
              },

            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          },
        }
      },
      computed:{
        columns: function(){
          return [
            {
              type: 'index'
            },
            {
              label: '申请编号',
              field: 'pay__applicationNo'
            },
              {
                  label: '贷款编号',
                  field: 'fi__transactionNo'
              },
            {
              label: '客户姓名',
              field: 'fi__customerName'
            },


            {
              label: '申请放款金额',
              field: 'pay__totalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '申请放款日期',
              field: 'pay__paymentDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '申请时间',
              field: 'pay__applicationDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD HH:mm:ss')
              }
            },

            {
              label: '状态',
              field: 'pay__applicationStatus',
              formatter: function (r,c,v) {
                return Status2CN('Loan__'+v)
              }
            },
              {
                  label: '当前待审批节点',
                  field: 'pay__nodeName',
                  formatter: function (r,c,v) {
                      if(r.pay__applicationStatus=='Rejected'){
                          v=''
                      }
                      return v
                  }
              },

            {
              label: '操作',
              opts:[
                {
                  label: '查看',
                  class: 'el-icon-view',
                  clickHandler: (index, row) => {
                    this.$router.push({
                      name: 'LoanApprovedViewView',
                      query: {
                        'applicationId': row.pay__applicationId,

                      }
                    })

                  },
                },
                {
                  class: 'el-icon-download',
                  name: '打印用款申请审批表',
                  clickHandler: (index, row)=>{
                    this.exportPdf(index, row)
                  },
                  conditions: row=> {
                    return row.pay__applicationStatus=='Completed'||row.pay__applicationStatus=='Approved'

                  }
                },
                {
                    label: row=> {
                        let name  = '审核';
                        (this.listData.variables.procInfo||[]).forEach(item=>{
                            if(item.roleId==row.pay__roleId){
                                name = item.name
                            }
                        })

                        return name
                    },
                  class: 'el-icon-success',
                  clickHandler: (index, row) => {
                    this.$router.push({
                      name: 'LoanApprovedView',
                      query: {
                        'applicationId': row.pay__applicationId,

                      }
                    })

                  },
                  conditions: row=> {
                    return row.pay__hasRole == 'true' &&row.pay__applicationStatus=='Pending Approval'

                  }
                },
               /* {
                  label: '财务初审',
                  class: 'el-icon-success',
                  clickHandler: (index, row) => {
                    this.$router.push({
                      name: 'LoanApprovedView',
                      query: {
                        'applicationId': row.pay__applicationId,
                        'role':'CW'
                      }
                    })

                  },
                  conditions: row=> {
                    return row.pay__hasRole == 'true' && row.pay__roleId==this.listData.variables.r1&&row.pay__applicationStatus=='Pending Approval'

                  }
                },
                {
                  label: '风控审核',
                  class: 'el-icon-success',
                  clickHandler: (index, row) => {
                    this.$router.push({
                      name: 'LoanApprovedView',
                      query: {
                        'applicationId': row.pay__applicationId,

                      }
                    })

                  },
                  conditions: row=> {
                    return row.pay__hasRole == 'true' && row.pay__roleId==this.listData.variables.r2&&row.pay__applicationStatus=='Pending Approval'

                  }
                },
                {
                  label: '副总审核',
                  class: 'el-icon-success',
                  clickHandler: (index, row) => {
                    this.$router.push({
                      name: 'LoanApprovedView',
                      query: {
                        'applicationId': row.pay__applicationId,

                      }
                    })

                  },
                  conditions: row=> {
                    return row.pay__hasRole == 'true' && row.pay__roleId==this.listData.variables.r3&&row.pay__applicationStatus=='Pending Approval'

                  }
                },
                  {
                      label: '总经理审核',
                      class: 'el-icon-success',
                      clickHandler: (index, row) => {
                          this.$router.push({
                              name: 'LoanApprovedView',
                              query: {
                                  'applicationId': row.pay__applicationId,


                              }
                          })

                      },
                      conditions: row=> {
                          return row.pay__hasRole == 'true' && row.pay__roleId==this.listData.variables.r4&&row.pay__applicationStatus=='Pending Approval'

                      }
                  },
                  {
                      label: '财务复核',
                      class: 'el-icon-success',
                      clickHandler: (index, row) => {
                          this.$router.push({
                              name: 'LoanApprovedView',
                              query: {
                                  'applicationId': row.pay__applicationId,
                                  'role':'cwzj',

                              }
                          })

                      },
                      conditions: row=> {
                          return row.pay__hasRole == 'true' && row.pay__roleId==this.listData.variables.r5&&row.pay__applicationStatus=='Pending Approval'

                      }
                  },*/
                  {
                      label: '撤回',
                      class: ' el-icon-back',
                      clickHandler: (index, row) => {
                          this.$confirm('是否确认撤回用款申请？一旦撤回，审核人将无法再审核','撤回用款')
                              .then(()=> {
                                  xhr.RevokeApprovingFinancingPayment(
                                      {
                                          'pay.applicationId': row.pay__applicationId,
                                      },
                                      res=> {
                                          try{
                                              if(res.data.status == 'success') {
                                                  this.getData()
                                              }else{
                                                  this.$message.error(res.data.msgs[0].text)
                                              }

                                          }catch (e) {

                                              this.$message.error(error.msgs[0].text)

                                          }
                                      }
                                  )
                              })
                              .catch(()=> {

                              })
                      },
                      conditions: row=> {
                          return row.pay__applicationStatus=='Pending Approval'&&this.$store.state.userInfo.u__userId === row.pay__createdBy

                      }
                  },

              ]
            }
          ]
        },
        filterParams: {
          get: function() {
            return {
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,
              'xlist.search.pay.applicationStatus' : this.applicationStatus,
              'xlist.search.pay.applicationStatus.op' : 'in',
              'xlist.sort.dataField': 'pay.applicationDate',
              'xlist.sort.order': 'desc'
            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getData()
        },
      },
      mounted(){
        this.getData()
      },
      methods:{
        getData: function () {
          xhr.getFinancingPaymentForApprovalList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res => {
              try {
                this.listData = res.data
                  this.listData.data.forEach(item=>{
                      item.pay__nodeName = (this.listData.variables.procInfo.find(item2=>item2.type ===item.pay__nodeType)||{}).name


                  })
              } catch (e) {

              }
            })
        },
        exportPdf: function (index, row) {
          try {
            window.open('/ix/fang/financing/LoanApproved.jasper?applicationId='+row.pay__applicationId)
          }
          catch (e) {

          }
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/LoanApprovalList.vue